import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '../../../common/feature/base-toolbar-feature';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { isShapeModel } from '@src/slide/domain/ui-model/elements/element-judge';

@Feature()
export class ShapeTabFeature extends BaseToolbarFeature {
    public constructor() {
        super();
    }

    public shouldDisabledTextBorder() {
        const model = this.getSelectModel() as IElementBaseModel;
        const models = getAllChildModels(model);
        return !models.filter(isShapeModel).length;
    }
}
